import React, { useEffect, useState } from "react";
import { Flex, Text, LoadingIndicator } from "@jsq/ds/core";
import { Sizes } from "@jsq/ds/styles";
import { getUserConversations } from "../../api/clients/conversationClient";
import * as styles from "./styles_vanilla.css";
import type { Conversation } from "../../api/types";

export type ChatHistoryPanelProps = {
  onHistoryItemClick: (conversationId: string) => void;
};

export const ChatHistoryPanel: React.FC<ChatHistoryPanelProps> = ({ onHistoryItemClick }) => {
  const [conversations, setConversations] = useState<Conversation[] | undefined>(undefined);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let cancelled = false;
    setLoading(true);

    getUserConversations()
      .then((data) => {
        if (cancelled) return;
        setConversations(data.conversations);
      })
      .catch(() => {
        if (cancelled) return;
        setConversations(undefined);
      })
      .finally(() => {
        if (cancelled) return;
        setLoading(false);
      });

    return () => {
      cancelled = true;
    };
  }, []);

  return (
    <Flex flexDirection="column" gap={Sizes.SM} className={styles.historyPanel}>
      <Text variant="secondary-sm" className={styles.historyHeader}>
        CHAT HISTORY
      </Text>
      <Flex flexDirection="column" gap={Sizes.SM} flexGrow={1} className={styles.historyList}>
        {loading ? (
          <LoadingIndicator />
        ) : (
          conversations?.map((conversation) => {
            return (
              <Text
                className={styles.historyItem}
                key={conversation.id}
                onClick={() => onHistoryItemClick(conversation.id)}
              >
                {conversation.title}
              </Text>
            );
          })
        )}
      </Flex>
    </Flex>
  );
};
